import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

export class FinanceMonthlyStatsWidget extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            loading: true,
            caller: props.Caller,
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/dashboard/widget/get", { name: 'FinanceMonthlyStatsWidget' })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false,
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {

        const months = ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور','مهر','آبان','آذر','دی','بهمن','اسفند'];
        const invoiceAmounts = this.state.data.invoiceAmounts;
        const invoiceCounts = this.state.data.invoiceCounts;
        const factorAmounts = this.state.data.factorAmounts;
        const factorCounts = this.state.data.factorCounts;
        const chartData = {
            labels: months,
            datasets: [
                {
                    label: 'مبلغ صورتحسابها',
                    data: invoiceAmounts,
                    borderColor: '#6c63ff',
                    backgroundColor: 'rgba(108,99,255,0.1)',
                    yAxisID: 'y',
                },
                {
                    label: 'تعداد صورتحسابها',
                    data: invoiceCounts,
                    borderColor: '#00bcd4',
                    backgroundColor: 'rgba(0,188,212,0.1)',
                    yAxisID: 'y1',
                },
                {
                    label: 'مبلغ فاکتورهای فروش',
                    data: factorAmounts,
                    borderColor: '#ff6b81',
                    backgroundColor: 'rgba(255,107,129,0.1)',
                    yAxisID: 'y',
                },
                {
                    label: 'تعداد فاکتورهای فروش',
                    data: factorCounts,
                    borderColor: '#00b894',
                    backgroundColor: 'rgba(0,184,148,0.1)',
                    yAxisID: 'y1',
                },
            ],
        };

        const chartFont = {
            family: 'IRANSans, Tahoma, Arial, sans-serif',
            size: 13,
            weight: 'normal',
        };
        const chartOptions = {
            responsive: true,
            plugins: {
                legend: {
                    position: 'top',
                    labels: {
                        font: chartFont,
                        color: '#222',
                    },
                },
                title: {
                    display: true,
                    text: 'نمودار مبلغ و تعداد فاکتورها و تراکنش‌ها (ماهانه)',
                    font: { ...chartFont, size: 16, weight: 'bold' },
                    color: '#2d3748',
                },
                tooltip: {
                    bodyFont: chartFont,
                    titleFont: { ...chartFont, size: 14, weight: 'bold' },
                },
            },
            scales: {
                y: {
                    type: 'linear',
                    display: true,
                    position: 'left',
                    title: {
                        display: true,
                        text: 'مبلغ (ریال)',
                        font: chartFont,
                        color: '#444',
                    },
                    ticks: {
                        callback: (v) => v.toLocaleString(),
                        font: chartFont,
                        color: '#444',
                    },
                },
                y1: {
                    type: 'linear',
                    display: true,
                    position: 'right',
                    grid: { drawOnChartArea: false },
                    title: {
                        display: true,
                        text: 'تعداد',
                        font: chartFont,
                        color: '#444',
                    },
                    ticks: {
                        font: chartFont,
                        color: '#444',
                    },
                },
                x: {
                    ticks: {
                        font: chartFont,
                        color: '#444',
                    },
                },
            },
        };

        return <div className="no-drag-widget">
            <Line data={chartData} options={chartOptions} height={100} />
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.renderForm(),
            ];

        return contents;
    }
}